/**
 * The one mark that carries product truth: can you play this, yes or no.
 *
 * It reads as ink pressed onto card - rotated a couple of degrees, with a
 * ragged double rule - and it is the only element allowed to make a claim
 * about availability. Playable is solid; coming soon is dashed and hollow, so
 * the two never depend on colour alone.
 */

import { useI18n } from "../i18n";

export interface StampProps {
  status: "playable" | "coming-soon";
  className?: string;
}

export function Stamp({ status, className }: StampProps) {
  const { t } = useI18n();
  const playable = status === "playable";
  return (
    <span
      className={`stamp ${className ?? ""}`}
      data-status={status}
      title={playable ? t("portal.status.playable") : t("portal.status.comingSoon")}
    >
      <span className="stamp__word">{playable ? t("portal.stamp.play") : t("portal.stamp.soon")}</span>
      <span className="stamp__sub">
        {playable ? t("portal.status.playable") : t("portal.status.comingSoon")}
      </span>
    </span>
  );
}
